import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./Resource.css"

export const Resource = () => {
  return (
        <>
        <RoutingMenu activeScreen="resource" />
    <div className=''>

        <iframe
            src={`${config.RootUrl}/faculty/library/resources/resourceHTML.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
